import React from 'react';
import PropTypes from 'prop-types';
import {
  EVMenuItem,
  EVIconButton,
  EVMenuIcon,
  EVMenu,
  EVButton,
} from '@eagleview/ev-comp-library';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { ASSESS_ANOMALIES_TESTSQUARE, ASSESS_GEOMETRY_TESTSQUARE } from 'layout/entitleUser/EntitleUser.constants';
import useStyles from './TestsquareMenu.styles';
import { TESTSQUARE_MENU_ACTIONS } from './TestsquareMenu.constants';
import { TEST_SQUARE_DIMENSION_5X20 } from '../Adjuster.constants';

const TestsquareMenu = ({
  position, onMenuOptionSelect, isMoveEnabled, changeSize, isTestSquareDataCorrupted,
}) => {
  const { t } = useTranslation();
  const classes = useStyles({ pixelPosition: position });

  const isAnomaliesTestsquareEnabled = useSelector((state) => get(
    state.entitleUserReducer.featureFlags,
    ASSESS_ANOMALIES_TESTSQUARE,
    false,
  ));

  const isGeometryTestsquareEnabled = useSelector((state) => get(
    state.entitleUserReducer.featureFlags,
    ASSESS_GEOMETRY_TESTSQUARE,
    false,
  ));

  const menuOptions = [
    {
      label: 'adjuster.testSquareMenu.Move',
      action: TESTSQUARE_MENU_ACTIONS.MOVE,
      show: true,
      disabled: false,
    },
    {
      label: 'adjuster.testSquareMenu.AnomalyDecisions',
      action: TESTSQUARE_MENU_ACTIONS.ANOMALY_DECISIONS,
      show: isAnomaliesTestsquareEnabled,
      disabled: false,
    },
    {
      label: changeSize === TEST_SQUARE_DIMENSION_5X20
        ? 'adjuster.testSquareMenu.ChangeSize.5x20'
        : 'adjuster.testSquareMenu.ChangeSize.10x10',
      action: TESTSQUARE_MENU_ACTIONS.CHANGE_SIZE,
      show: isGeometryTestsquareEnabled,
      disabled: isTestSquareDataCorrupted,
      title: 'adjuster.testSquareMenu.ChangeSize.optionNotAvailable',
    },
  ];

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuOptionSelect = (option) => {
    onMenuOptionSelect(option);
    handleMenuClose();
  };

  if (isMoveEnabled) {
    return (
      <EVButton
        className={classes.testSquareSetButton}
        variant="contained"
        size="small"
        onClick={() => onMenuOptionSelect(TESTSQUARE_MENU_ACTIONS.SET_LOCATION)}
      >
        {t('adjuster.testSquareMenu.SetLocation')}
      </EVButton>
    );
  }

  return (
    <>
      <EVIconButton
        aria-controls="testsquare-menu"
        className={classes.testSquareMenu}
        aria-haspopup="true"
        onClick={handleMenuClick}
      >
        <EVMenuIcon />
      </EVIconButton>
      <EVMenu
        id="testsquare-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        {
          menuOptions.map((option) => (
            option.show && (
              <EVMenuItem
                onClick={() => {
                  if (!option.disabled) {
                    handleMenuOptionSelect(option.action);
                  }
                }}
                className={option.disabled ? classes.disabledMenuItem : ''}
                title={option.disabled ? t(option.title) : ''}
              >
                {t(option.label)}
              </EVMenuItem>
            )
          ))
        }
      </EVMenu>
    </>
  );
};

TestsquareMenu.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  onMenuOptionSelect: PropTypes.func.isRequired,
  isMoveEnabled: PropTypes.bool,
  changeSize: PropTypes.string,
  isTestSquareDataCorrupted: PropTypes.bool,
};

TestsquareMenu.defaultProps = {
  position: { x: 0, y: 0 },
  isMoveEnabled: false,
  changeSize: TEST_SQUARE_DIMENSION_5X20,
  isTestSquareDataCorrupted: false,
};

export default TestsquareMenu;
